import { DataCache, QueryResultRelationship, QueryResultsRelationship, SharedKeyRelationship } from 'lib/DataCache';
import { PCCache, PCCollection } from 'data/PCCache';

import { PortCallProfileResponse, PortCallProfileTopicCard } from 'data/models/PortCallProfile';
import { PortCallReport } from 'data/models/PortCallReport';

export class PortCallProfileCache extends DataCache {

    PortCallProfileResponses = PCCollection(PortCallProfileResponse);
    PortCallProfileTopicCards = PCCollection(PortCallProfileTopicCard);
    PortCallReports = PCCollection(PortCallReport);

    constructor(data : PCCache) {
        super();

        new QueryResultsRelationship(this.PortCallProfileResponses, this.PortCallProfileTopicCards, r => r.TopicCards);
        new SharedKeyRelationship   (this.PortCallProfileResponses, data.PortCalls            , q => q.PortCall, null);
        new SharedKeyRelationship   (this.PortCallProfileTopicCards, data.TopicCards, c => c.Card, null);
        new QueryResultRelationship(this.PortCallReports, data.PortCalls, pc => pc.CurrentPC);
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/portcallprofile/cache.ts